import * as RadixDropdown from '@radix-ui/react-dropdown-menu';
import { cx } from 'class-variance-authority';
import { forwardRef } from 'react';
import type { ContentProps } from '../dropdown.types';

const Content = forwardRef<HTMLDivElement, ContentProps>(({ children, sideOffset = 4, className, ...props }, ref) => {
  return (
    <RadixDropdown.Content
      ref={ref}
      sideOffset={sideOffset}
      className={cx(
        'min-w-[120px] max-w-[min(360px,calc(100vw-32px))]',
        'bg-elevated rounded-default border border-tertiary origin-[var(--radix-dropdown-menu-content-transform-origin)] overflow-auto z-[60] shadow-md',
        'data-[side=bottom]:animate-[slideDown_var(--duration-ultra-fast)]',
        'data-[side=top]:animate-[slideUp_var(--duration-ultra-fast)]',
        'data-[side=left]:animate-[slideRight_var(--duration-ultra-fast)]',
        'data-[side=right]:animate-[slideLeft_var(--duration-ultra-fast)]',
        'data-[state=open]:animate-[scaleIn_var(--duration-ultra-fast)]',
        'data-[state=closed]:animate-[scaleOut_var(--duration-ultra-fast)]',
        className,
      )}
      {...props}
    >
      {children}
    </RadixDropdown.Content>
  );
});

export default Content;
